var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11L7 11C6.44771 11 6 11.4477 6 12C6 12.5523 6.44771 13 7 13L17 13Z",
    fill: "#495171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveSort);
export default __webpack_public_path__ + "static/media/inactive-sort.20ebd5cd8a8e0c18463ba2eb52df2bc0.svg";
export { ForwardRef as ReactComponent };